/* eslint-env jquery */

import update from 'immutability-helper';
import PropTypes from 'prop-types';
import { Component } from 'react';
import 'blueimp-file-upload/js/jquery.fileupload';

import UploadButton from 'hb-react/shared/components/file/UploadButton';
import Loader from 'hb-react/shared/components/Loader';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

class FilesUpload extends Component {
  constructor(props) {
    super(props);

    this.filesUploadedCount = 0;
  }

  state = {
    uploads: this.props.uploads || [],
    loading: false,
  };

  componentDidMount() {
    this.setupFileUplod();
  }

  componentDidUpdate() {
    this.setupFileUplod();
  }

  componentWillUnmount() {
    try {
      $(this.fileInput).fileupload('destroy');
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn(e);
    }
  }

  setupFileUplod = () => {
    const { uploadParams, fileUploadRoute } = this.props;
    const { uploads } = this.state;

    const path = fileUploadRoute(uploadParams);

    $(this.fileInput).fileupload({
      dataType: 'json',
      singleFileUploads: true,
      url: path,
      add: (e, data) => {
        this.fileUploadSarted();
        data.submit();
      },
      done: (e, data) => {
        const newUploads = update(uploads, { $push: [data.result] });

        this.setState({
          uploads: newUploads,
        });
      },
      always: () => {
        this.fileUploadFinished();
      },
    });
  };

  fileUploadSarted = () => {
    this.filesUploadedCount += 1;
    if (this.filesUploadedCount !== 0) {
      this.setState({ loading: true });
    }
  };

  fileUploadFinished = () => {
    this.filesUploadedCount -= 1;
    if (this.filesUploadedCount === 0) {
      this.setState({ loading: false });
    }
  };

  handleFileRemove = (e, upload) => {
    const { fileDeleteRoute, uploadParams } = this.props;
    const { uploads } = this.state;

    e.stopPropagation();

    this.setState({ loading: true });
    axios
      .delete(
        fileDeleteRoute({
          network_id: uploadParams.network_id,
          upload_id: upload.id,
        }),
      )
      .then(() => {
        const index = uploads.findIndex((u) => u.id === upload.id);
        const newUploads = update(uploads, { $splice: [[index, 1]] });

        this.setState({
          uploads: newUploads,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  render() {
    const { icon = 'icon-plus-large' } = this.props;
    const { uploads, loading } = this.state;

    return (
      <div className="relative">
        {uploads.map((upload) => (
          <span
            key={upload.id}
            className="inline-block soft-half--bottom soft-half--right"
          >
            <UploadButton
              label={upload.file_name}
              url={upload.file_url}
              onDelete={(e) => this.handleFileRemove(e, upload)}
            />
          </span>
        ))}
        <span className="inline-block soft-half--bottom soft-half--right">
          <UploadButton icon={icon} onClick={() => $(this.fileInput).click()} />
          <input
            type="file"
            name="file"
            multiple
            ref={(r) => (this.fileInput = r)}
            className="deprecated--visuallyhidden"
            aria-label={__('Files Upload')}
          />
        </span>
        {loading && <Loader fillParent small />}
      </div>
    );
  }
}

FilesUpload.propTypes = {
  uploads: PropTypes.arrayOf(PropTypes.object),
  fileUploadRoute: PropTypes.func,
  fileDeleteRoute: PropTypes.func,
  uploadParams: PropTypes.shape({
    uploadable_id: PropTypes.number.isRequired,
    uploadable_type: PropTypes.string.isRequired,
  }),
};

FilesUpload.defaultProps = {
  fileUploadRoute: Routes.attach_file_uploads_path,
  fileDeleteRoute: Routes.delete_file_uploads_path,
};

export default FilesUpload;
